import React from 'react';
import PropTypes from 'prop-types';
import { H2, Flex, Badge, Button } from '@decisiv/ui-components';
import ExclamationCircleF from '@decisiv/iconix/lib/components/Info';
import { t } from '@lingui/macro';
import { CenteredContainer, HelpInputMessage } from './style';

export default function NotFound({ title, description = '' }) {
  return (
    <CenteredContainer flexDirection="column" padding={1}>
      <Badge
        key="ErrorBadge"
        aria-label="Error Badge"
        color="licoriceMousse"
        icon={ExclamationCircleF}
        size="large"
        palette="bright"
      />
      <Flex>
        <H2>{title}</H2>
      </Flex>
      <HelpInputMessage>{description}</HelpInputMessage>

      <Flex marginTop={2}>
        <Button
          text={t`Return Home`}
          aria-label={t`Button to Return Home`}
          onClick={() => {
            window.location.href = '/';
          }}
        />
      </Flex>
    </CenteredContainer>
  );
}
NotFound.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string.isRequired,
};
